import { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { AppBarTitlePortal } from '../../../../common/components/atoms/AppBarTitlePortal';
import { useAirportFileExplorer } from '../core/repositories/airportFiles/hook';
import FileExplorer from '../molecules/FileExplorer';

export default function AirportReports(): ReactElement {
  const { t } = useTranslation('Repository');
  const fileExplorerProps = useAirportFileExplorer();

  return (
    <>
      <AppBarTitlePortal>
        <h4>{t('Title')}</h4>
      </AppBarTitlePortal>
      <FileExplorer {...fileExplorerProps} />
    </>
  );
}
